import { ReactNode } from "react";
import cx from "classnames";
import { useTheme } from "@/components/Theme";
import { SimulatorChannel } from "@/api/simulator/simulator.model";
import styles from "./SimulatorChannelIcon.module.scss";
import { Ticket03Icon } from "@/v2/assets/icons/Ticket03Icon";
import { Comment01Icon } from "@/v2/assets/icons/Comment01Icon";
import { Rotate3d } from "@/v2/assets/icons/3dRotate";
import { SidebarRight } from "@/v2/assets/icons/SidebarRight";
import { Slack } from "@/v2/assets/icons/Slack";

function TicketsSVG() {
  return (
    <div
      style={{
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#EDF6FF",
        borderRadius: "4px",
      }}
    >
      <Ticket03Icon size={16} fill="blue" />
    </div>
  );
}

function DarkTicketsSVG() {
  return (
    <div
      style={{
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#11253F",
        borderRadius: "4px",
      }}
    >
      <Ticket03Icon size={16} fill="blue" />
    </div>
  );
}

function HelpCenterSVG() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z"
        fill="#EDFADA"
      />
      <path
        d="M9 14C9 10.6863 11.6863 8 15 8H25C28.3137 8 31 10.6863 31 14V26C31 29.3137 28.3137 32 25 32H9V14Z"
        fill="#699200"
        fillOpacity="0.671"
      />
      <path
        d="M13.3333 15.8333C13.3333 15.3731 13.7063 15 14.1666 15H25.8333C26.2935 15 26.6666 15.3731 26.6666 15.8333C26.6666 16.2936 26.2935 16.6667 25.8333 16.6667H14.1666C13.7063 16.6667 13.3333 16.2936 13.3333 15.8333Z"
        fill="#EDFADA"
      />
      <path
        d="M13.3333 19.1666C13.3333 18.7064 13.7063 18.3333 14.1666 18.3333H25.8333C26.2935 18.3333 26.6666 18.7064 26.6666 19.1666C26.6666 19.6269 26.2935 20 25.8333 20H14.1666C13.7063 20 13.3333 19.6269 13.3333 19.1666Z"
        fill="#EDFADA"
      />
      <path
        d="M13.3333 22.5C13.3333 22.0398 13.7063 21.6667 14.1666 21.6667H25.8333C26.2935 21.6667 26.6666 22.0398 26.6666 22.5C26.6666 22.9603 26.2935 23.3334 25.8333 23.3334H14.1666C13.7063 23.3334 13.3333 22.9603 13.3333 22.5Z"
        fill="#EDFADA"
      />
    </svg>
  );
}

function DarkHelpCenterSVG() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z"
        fill="#1F2711"
      />
      <path
        d="M9 14C9 10.6863 11.6863 8 15 8H25C28.3137 8 31 10.6863 31 14V26C31 29.3137 28.3137 32 25 32H9V14Z"
        fill="#D1FF44"
        fillOpacity="0.477"
      />
      <path
        d="M13.332 15.8333C13.332 15.3731 13.7051 15 14.1654 15H25.832C26.2923 15 26.6654 15.3731 26.6654 15.8333C26.6654 16.2936 26.2923 16.6667 25.832 16.6667H14.1654C13.7051 16.6667 13.332 16.2936 13.332 15.8333Z"
        fill="#1F2711"
      />
      <path
        d="M13.332 19.1666C13.332 18.7064 13.7051 18.3333 14.1654 18.3333H25.832C26.2923 18.3333 26.6654 18.7064 26.6654 19.1666C26.6654 19.6269 26.2923 20 25.832 20H14.1654C13.7051 20 13.332 19.6269 13.332 19.1666Z"
        fill="#1F2711"
      />
      <path
        d="M13.332 22.5C13.332 22.0398 13.7051 21.6667 14.1654 21.6667H25.832C26.2923 21.6667 26.6654 22.0398 26.6654 22.5C26.6654 22.9603 26.2923 23.3334 25.832 23.3334H14.1654C13.7051 23.3334 13.332 22.9603 13.332 22.5Z"
        fill="#1F2711"
      />
    </svg>
  );
}

function LiveChatSVG() {
  return (
    <div
      style={{
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 145, 1, 0.165)",
        borderRadius: "4px",
      }}
    >
      <Comment01Icon size={16} fill="orange" />
    </div>
  );
}

function DarkLiveChatSVG() {
  return (
    <div
      style={{
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(253, 55, 0, 0.122)",
        borderRadius: "4px",
      }}
    >
      <Comment01Icon size={16} fill="orange" />
    </div>
  );
}

function CopilotSVG() {
  return (
    <div
      style={{
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(2, 192, 150, 0.095)",
        borderRadius: "4px",
      }}
    >
      <SidebarRight size={16} fill="teal" />
    </div>
  );
}

function DarkCopilotSVG() {
  return (
    <div
      style={{
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 254, 174, 0.074)",
        borderRadius: "4px",
      }}
    >
      <SidebarRight size={16} fill="teal" />
    </div>
  );
}

function SlackbotSVG() {
  return (
    <div
      style={{
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#FCEFFC",
        borderRadius: "4px",
      }}
    >
      <Slack size={16} fill="purple" />
    </div>
  );
}

function DarkSlackbotSVG() {
  return (
    <div
      style={{
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#341B34",
        borderRadius: "4px",
      }}
    >
      <Slack size={16} fill="purple" />
    </div>
  );
}

const simulatorChannelToIcon: Record<
  SimulatorChannel,
  { light: ReactNode; dark: ReactNode }
> = {
  helpcenter: { light: <HelpCenterSVG />, dark: <DarkHelpCenterSVG /> },
  autonomous_ticket_event: { light: <TicketsSVG />, dark: <DarkTicketsSVG /> },
  autonomous_quackchat: { light: <LiveChatSVG />, dark: <DarkLiveChatSVG /> },
  slackbot: { light: <SlackbotSVG />, dark: <DarkSlackbotSVG /> },
  copilot: { light: <CopilotSVG />, dark: <DarkCopilotSVG /> },
  knowledge_hub: {
    light: (
      <div
        style={{
          width: "24px",
          height: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(1, 204, 255, 0.114)",
          borderRadius: "4px",
        }}
      >
        <Rotate3d size={16} fill="cyan" />
      </div>
    ),
    dark: (
      <div
        style={{
          width: "24px",
          height: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(1, 204, 255, 0.114)",
          borderRadius: "4px",
        }}
      >
        <Rotate3d size={16} fill="cyan" />
      </div>
    ),
  },
};

interface SimulatorChannelIconProps {
  channel: SimulatorChannel;
  size?: "1" | "2" | "3" | "4" | "5";
}

export function SimulatorChannelIcon({
  channel,
  size = "2",
}: SimulatorChannelIconProps) {
  const { isDarkMode } = useTheme();
  const svg = simulatorChannelToIcon[channel][isDarkMode ? "dark" : "light"];

  return (
    <span className={cx(styles.SimulatorChannelIcon, styles[`size-${size}`])}>
      {svg}
    </span>
  );
}
